module.exports = __webpack_public_path__ + "media/images/common/footer_logo-9f9a9fe849c3c89b0ff8f6e306afc511.png";